import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';

let pending;
let sample;
const monotonic = () => window.performance?.now() ?? Date.now();

export const getArgentinaTime = async () => {
  if (pending) return pending;
  if (sample && monotonic() - sample.received < 15000) return sample.value + monotonic() - sample.received;
  const getArgentinaTimeFn = httpsCallable(functions, 'getArgentinaUnixTimeV2');

  try {
    pending = getArgentinaTimeFn().then(result => {
      if (!Number.isFinite(result.data)) throw new Error('La hora del servidor no es válida');
      sample = {value: result.data, received: monotonic()};
      return result.data;
    });
    return await pending;
  } catch (error) {
    console.error('Error al obtener la hora de Argentina:', error);
    throw error;
  } finally {
    pending = null;
  }
};
